module.exports = __webpack_public_path__ + "img/small.86d76177.jpg";